import type { Revision } from './configModel';
import { revisionSchema } from './configModel';
import { objectSchemaOf, Joi } from '../helpers';

export interface ILoadUserParams {
  revision?: Revision;
  uid: string;
}

export const loadUserParamsSchema = objectSchemaOf<ILoadUserParams>({
  revision: Joi.alternatives(revisionSchema).optional(),
  uid: Joi.string().required(),
});
